module.exports = __webpack_public_path__ + "assets/icon-set.7a1f4166.svg";